export default __webpack_public_path__ + "static/media/thumb-Multi-GNSS-Module-2.a04326a4.png";